import { render } from "./DeleteUserGroup.vue?vue&type=template&id=f3e01b02"
import script from "./DeleteUserGroup.vue?vue&type=script&lang=js"
export * from "./DeleteUserGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__